import styled, { css } from 'styled-components'
import { styleAnchorBlock } from '../../../lib/styles/Style'
import { typoHeading6 } from '../../../lib/styles/Typography'
import CustomLink from '../../CustomLink'

const Css = {
  Image: css`
    flex: 0 0 auto;
    width: 2.5rem;
    aspect-ratio: 5 / 7;
    border: solid 1px ${({ theme }) => theme.colors.black[5]};
    border-radius: 0.2rem;
    object-fit: cover;
  `,
}

export const Styled = {
  Downloads: styled.ul`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0;
    margin: 0;
  `,
  Item: styled.li`
    list-style: none;
  `,
  ItemLink: styled(CustomLink)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    color: ${({ theme }) => theme.colors.black[1]};
    ${styleAnchorBlock}
  `,
  ItemImage: styled.img`
    ${Css.Image}
  `,
  ItemPlaceholder: styled.div`
    ${Css.Image}
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      width: 1.3rem;
      height: 1.3rem;
    }

    svg {
      color: ${({ theme }) => theme.colors.black[4]};
    }
  `,
  ItemHeadline: styled.h3`
    ${typoHeading6}
    margin-bottom: 0.2rem;
  `,
  ItemMeta: styled.div`
    font-size: 0.9rem;
    line-height: 1.1;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black[3]};
    display: flex;
    flex-wrap: wrap;
    /* align-items: center; */
    gap: 0.3rem;

    span {
      &:not(:last-child) {
        display: flex;
        gap: 0.3rem;

        &:after {
          display: block;
          content: '·';
        }
      }
    }
  `,
  ItemBody: styled.div`
    flex: 1 1 auto;
  `,
}
